import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'snagRisk',
  standalone: true,
})
export class SnagRiskPipe implements PipeTransform {
  colors = [
    { status: 'No Risk', value: '#94A3B8' },
    { status: 'Low Risk', value: '#00c851' },
    { status: 'Medium Risk', value: '#ffbb33' },
    { status: 'High Risk', value: '#ff3547' },
    { status: 'Danger', value: '#111827' },
  ];

  transform(value: string): string {
    const match = this.colors.find((c) => c.status === value);
    return match ? match.value : '';
  }
}
